export async function checkIfPushNotificationsWork(): Promise<boolean> {
    if (!('serviceWorker' in navigator)) {
        console.error('Service workers are not supported by this browser');
        return false;
    }

    if (!('PushManager' in window)) {
        console.error('Push notifications are not supported by this browser');
        return false;
    }

    if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
        console.error('Notifications are not supported by this browser');
        return false;
    }

    if (Notification.permission !== "granted") {
        console.error('Notifications are not granted by the user');
        return false;
    }

    return true;
}